import { Row } from 'react-table';
import { IProductKeyword } from 'types';

export const caseInsensitiveStringsOrder = (rowA: Row, rowB: Row, columnId: string, desc?: boolean) => {
    const defaultVal = desc ? 'ZZZZZZZZZZZZZ' : '';
    const firstVal: string = rowA.values[columnId] ?? defaultVal;

    const secondVal: string = rowB.values[columnId] ?? defaultVal;

    return firstVal.localeCompare(secondVal, undefined, { sensitivity: 'base' });
};

export const sortProductKeywords = (rowA: Row, rowB: Row, columnId: string, desc?: boolean) => {
    if (
        columnId === 'keywords' ||
        (columnId === 'priority_keywords' &&
            Array.isArray(rowA.values['keywords']) &&
            Array.isArray(rowB.values['keywords']))
    ) {
        if (columnId === 'keywords') {
            const firstVal: string[] = rowA.values['keywords'].filter((k: IProductKeyword) => !k.is_priority);
            const secondVal: string[] = rowB.values['keywords'].filter((k: IProductKeyword) => !k.is_priority);
            return firstVal.length - secondVal.length;
        }
        if (columnId === 'priority_keywords') {
            const firstVal: string[] = rowA.values['keywords'].filter((k: IProductKeyword) => k.is_priority === true);
            const secondVal: string[] = rowB.values['keywords'].filter((k: IProductKeyword) => k.is_priority === true);
            return firstVal.length - secondVal.length;
        }
    }

    if (typeof rowA.values[columnId] === 'string' && typeof rowB.values[columnId] === 'string')
        return caseInsensitiveStringsOrder(rowA, rowB, columnId, desc);

    return 0;
};
